import {z} from 'zod';
import {PermissionMatrixSchema} from '@netx/core-permissions/schema';
import {PermissionName} from '@netx/core-permissions-next/constants';

export const CategorySchema = z.object({
	// normalizing categoryid to id
	id: z.number().int().gt(0),
	categoryid: z.number().int().gt(0),

	/** category ids for ancestors */
	ancestors: z.array(z.number()),
	/** primary asset id for category */
	assetId: z.number(),
	/** primary asset label for category */
	assetLabel: z.string(),
	/** size of all assets in category */
	byteCount: z.string(),
	/** attribute ids for category */
	categoryAttributes: z.array(z.number().int()),
	/** child category ids */
	children: z.array(z.number()),
	descendants: z.array(z.number()),
	/**
	 * `empty` - has neither children nor images\
	 * `categories` - has children\
	 * `images` - has images (but no children)
	 */
	contents: z.string(),
	/** ex: 2021-06-16 22:21:25.0 */
	creationDate: z.string(),
	/** user defined category description */
	description: z.string(),
	/** determines whether a category should be used as a facet */
	facet: z.boolean(),
	/** primary file path for category */
	file: z.string(),
	/** number of assets in category */
	fileCount: z.number(),
	/** whether or not the category has any assets */
	hasContents: z.boolean(),
	jwt: z.string(),
	/** last user to modify category */
	moduserlabel: z.string(),
	/** category name */
	name: z.string(),
	/** place in order */
	orderby: z.number(),
	/** parent category name */
	parentCategoryName: z.string(),
	/** parent category id */
	parentid: z.number(),
	/** path to category */
	path: z.string(),
	/** user permissions */
	permissionMatrix: PermissionMatrixSchema,
	previewUrl: z.string(),
	/** are permissions recursive */
	recursivePermission: z.boolean(),
	/** ex: "cat1/cat2/cat3" */
	repositorydirectory: z.string(),
	/** number of categories within parent category */
	subCategoryCount: z.number(),
	thumbUrl: z.string(),
	/**
	 * 0 - category id is less than 1 or it has no children or images
	 * 1 - category has children
	 * 2 - category has images (but no children)
	 * TODO: seek clarification on what images vs children means
	 */
	type: z.number(),
	/** id of user who created category */
	userId: z.number(),
	/** whether or not the category is visible (a boolean represented by a number) */
	visible: z.number(),

	permissions: z.array(z.nativeEnum(PermissionName)),
});

export type ICategory = z.infer<typeof CategorySchema>;

export const CategoryField = CategorySchema.keyof().enum;
